var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    transform: "translate(2 .5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.6056 6.32661c1.13026.89015 1.3249 2.52802.43475 3.65829l-1.93412 2.4558c-.89015 1.1303-2.52802 1.3249-3.65828.4348-1.13026-.8902-1.32491-2.5281-.43475-3.6583l1.61176-2.04654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.39538 7.8648c-1.13026-.89016-1.32491-2.52803-.43475-3.65828l1.93412-2.45583c.89015-1.13025 2.52805-1.3249 3.65825-.43474 1.1303.89015 1.3249 2.52802.4348 3.65828l-1.6118 2.04651"
  }))));
}
export default SvgLinkreact;